import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './ModelBuilderTabView.scss';
import {
  ExCard,
} from '@boomi/exosphere';
import { useBoomiAgentFoundationContext } from '@context/BoomiAgentFoundationContext';
import { providerLogo } from '@components/ModelsManagement';

interface ModelProvider {
  id: string;
  name: string;
  description: string;
  icon: string;
  configPath: string;
}

function ModelBuilderTabView({ hasAgentCreatePermission }: any) {
  const [t] = useTranslation('common');
  const navigate = useNavigate();
  const {
    setShowBuilderDialog,
  } = useBoomiAgentFoundationContext();

  const modelProviders: ModelProvider[] = [
    {
      id: 'Anthropic',
      name: 'Anthropic',
      description: t('anthropic_description'),
      icon: 'A',
      configPath: '/models?provider=anthropic',
    },
    {
      id: 'Google',
      name: 'Google',
      description: t('gemini_description'),
      icon: 'Star',
      configPath: '/models?provider=google',
    },
    {
      id: 'OpenAI',
      name: 'OpenAI',
      description: t('openai_description'),
      icon: 'Sparkles',
      configPath: '/models?provider=openai',
    },
  ];

  const handleAddModel = (configPath: string) => {
    setShowBuilderDialog(false);
    document.body.style.overflow = 'unset';
    navigate(configPath);
  };

  return (
    <div className="model-builder-container">
      <div className="agent-tool-info">
        {t('models_builder_text')}
      </div>

      <div className="template-cards-container">
        {hasAgentCreatePermission && modelProviders.map((provider) => (
          <ExCard
            className="template-card"
            key={provider.id}
            data-testid={`designer-dialog-model-card-${provider.id}`}
            onClick={() => handleAddModel(provider.configPath)}
          >
            <div
              slot="header"
              className="template-header"
              data-testid={`model-header-${provider.id}`}
            >
              <div className="model-image-container">
                <img
                  src={providerLogo(provider.id).src}
                  alt={providerLogo(provider.id).alt}
                  className="provider-logo-img"
                />
              </div>
            </div>
            <div className="template-content">
              <div className="agent-name">{provider.name}</div>
              <div className="agent-description">
                {provider.description}
              </div>
            </div>
          </ExCard>
        ))}
      </div>
    </div>
  );
}

export default ModelBuilderTabView;
